export default __webpack_public_path__ + "static/media/leaderAnalytics.84befd00.jpeg";